<pktr-app-menu #pktrAppMenu [env]="env" [idToken]="this.cookieService.get('idToken') || null" appVersion="2.0.0"
    source="sell"></pktr-app-menu>
<router-outlet></router-outlet>